module.exports = __webpack_public_path__ + "static/img/baidu.766f69d9.png";